import IconArrowRightBlack from "components/EvtKit/icons/IconArrowRightBlack"
import TabsList from "components/EvtKit/tabs/TabsList"
import CreatePlanTabTriggerButton from "./CreatePlanTabTriggerButton"
import { tabIds } from "pages/purchase-plans/constants/defaultValues"

import { memo, useCallback, useContext } from "react"
import styled from "styled-components"
import clsx from "clsx"
import SwitchV2 from "components/EvtKit/switch/SwitchV2"
import { TabsContext } from "components/EvtKit/tabs/Tabs"

const ButtonsTriggersContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
`

const TabsListContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`

const Divider = styled.div`
  border: 1px solid ${(props) => props.theme.palette.disabled};
  width: 100%;
  margin-top: 8px;
`

const SwitchContainer = styled.div`
  display: none;
  min-width: 220px;

  &.isVisible {
    display: block;
  }
`

interface CreatePlanTabProps {
  isBenefitStepDisabled: boolean
  isUpdate?: boolean
  isDevMode?: boolean
  toggleDevMode?: () => void
}

const CreatePlanTabList = (props: CreatePlanTabProps) => {
  const { isBenefitStepDisabled, isUpdate, toggleDevMode, isDevMode } = props

  const { activeTabId } = useContext(TabsContext)

  const isDevModeSwitchVisible = activeTabId === tabIds.plans

  const handleDevModeSwitch = useCallback(() => {
    if (!isDevModeSwitchVisible || !toggleDevMode) {
      return
    }

    toggleDevMode()
  }, [activeTabId, tabIds.plans, toggleDevMode])

  return (
    <TabsList>
      <TabsListContainer>
        <ButtonsTriggersContainer>
          <CreatePlanTabTriggerButton label="Plano" numberLabel="1." triggerId={tabIds.plans} isUpdate={isUpdate} />
          <IconArrowRightBlack />
          <CreatePlanTabTriggerButton
            label="Benefícios"
            numberLabel="2."
            triggerId={tabIds.benefits}
            disabled={isBenefitStepDisabled}
            isUpdate={isUpdate}
          />
        </ButtonsTriggersContainer>
        <SwitchContainer className={clsx({ isVisible: isDevModeSwitchVisible })}>
          <SwitchV2
            label="Modo Desenvolvedor"
            onChange={handleDevModeSwitch}
            variant="medium"
            value={isDevMode}
            disabled={isUpdate}
          />
        </SwitchContainer>
      </TabsListContainer>

      <Divider />
    </TabsList>
  )
}

export default memo(CreatePlanTabList)
